module.exports = __webpack_public_path__ + "static/media/beginner.7191fa65.gif";